import React from 'react';
import { FileListItem, FileName, FileSize, LinkName } from './styles';
import { FileDownloadDone, HighlightOff, Message } from '@mui/icons-material';
import {
    formatBytes,
    getMixedMediaFileSize,
    isFileToUpload,
    isUploadedMedia,
    mixedMediaIsLink,
    openInNewTab
} from '../../utils';
import { IconButton, TextButton } from '..';
import { FileToUpload, MixedMedia } from '../../types/Upload';
import { useTranslations } from 'next-intl';

type Props = {
    uploads: MixedMedia[];
    withDescription: boolean;
    withSource: boolean;
    onEditFileInfo: (id: number) => void;
    onRemoveItem: (id: number) => void;
};

const FileList = ({
    uploads,
    withDescription,
    withSource,
    onEditFileInfo,
    onRemoveItem
}: Props) => {
    const t = useTranslations('file_upload');

    const withAdditionalInfo = withDescription || withSource;

    const infoButtonLabel =
        withDescription && withSource
            ? t('add_file_desc_and_source')
            : withDescription
              ? t('add_file_description')
              : withSource
                ? t('add_file_source')
                : '';

    const renderFileName = (media: MixedMedia) => {
        if (mixedMediaIsLink(media))
            return (
                <LinkName
                    onClick={() =>
                        openInNewTab(isUploadedMedia(media) ? media.url : (media.data as string))
                    }
                >
                    {isUploadedMedia(media) ? media.url : (media.data as string)}
                </LinkName>
            );
        else if (isFileToUpload(media))
            return (
                <>
                    <FileName>{(media as FileToUpload).name}</FileName>
                    <FileSize>{formatBytes(getMixedMediaFileSize(media))}</FileSize>
                </>
            );
        else if (isUploadedMedia(media))
            return (
                <>
                    <FileName>{media.name}</FileName>
                    <FileSize>{formatBytes(getMixedMediaFileSize(media))}</FileSize>
                </>
            );
    };
    return (
        <>
            {uploads.map((upload) => (
                <FileListItem
                    key={isUploadedMedia(upload) ? upload.uniqueMediaId : upload.id}
                    hasDescriptionColumn={withAdditionalInfo}
                    isFile={!mixedMediaIsLink(upload)}
                >
                    <FileDownloadDone sx={{ mr: 2 }} />

                    {renderFileName(upload)}
                    {withAdditionalInfo ? (
                        upload.description || upload.source ? (
                            <IconButton
                                icon={<Message />}
                                onClick={() => onEditFileInfo(upload.id)}
                            />
                        ) : (
                            <TextButton
                                label={infoButtonLabel}
                                onClick={() => onEditFileInfo(upload.id)}
                            />
                        )
                    ) : null}
                    <IconButton icon={<HighlightOff />} onClick={() => onRemoveItem(upload.id)} />
                </FileListItem>
            ))}
        </>
    );
};

export { FileList };
